///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.front_store.maintenance = abcsetup.front_store.maintenance || {};
abcsetup.front_store.maintenance.edit = abcsetup.front_store.maintenance.edit || {};




///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Variables
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.front_store.maintenance.removeButtons = [];



///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.front_store.maintenance.edit = {
    init: function() {
        abcsetup.setTitle('Edit Consumer Item');
        abcsetup.front_store.maintenance.removeButtons = ['maintenance_approve_screenshot', 'outside_shipping_carton_label', 'sap_pricing_letter', 'ahp_pricing_letter', 'mwi_pricing_letter'];

        // Set the global item var
        abcsetup.item = JSON.parse($('form.front-store-item #item_object').html());
        abcsetup.form_manager.form = $('form.front-store-item');
        abcsetup.form_manager.setFormItems();

        // Init any field restrictions/values
        this._initFields();

        // Init the attachment buttons
        this._initAttachments();

        if (abcsetup.userRole && (abcsetup.userRole.class == 'vendor' || abcsetup.userRole.class == 'rx_vendor')){
            // The vendor should have the ability to edit the Case UPC, but only if they explicitly indicate to do so
            $("#case_upc").parent().append('<div class="btn btn-sm btn-outline-primary mt-2 toggle_field">Maintain field</div>');
        }

        // Toggle the input field related to this button
        $(document).on('click', '.toggle_field', function(event) {
            event.preventDefault();

            $(this).parent().find('input').attr('disabled',false).addClass('maintenance');
            $(this).hide();
        });


        if (abcsetup.userRole.class == 'vendor'){
            let hasImageElement = document.getElementById('has_image');
            if (hasImageElement) {

                // Bind the on change of the has_image select if the element exists
                this._hasImageSelectChanged();
                $('#has_image').on('change', this._hasImageSelectChanged);
            } else {
                console.warn('Element with id "has_image" not found.');
            }
        }

        // Delete attachment button clicked
        $(document).on('click', '.delete-attachment', function(event) {
            event.preventDefault();
            var _this = $(this);

            abcsetup.alerts.confirm('Delete Attachment', 'Are you sure you want to delete this attachment?', function (resp) {
                if (resp) {
                    _this.parent().fadeOut('slow', function() {
                        $(this).remove();

                        // Auto save the item form
                        // abcsetup.front_store.maintenance.edit._autoSave();
                        $('button#'+_this.attr("id")).addClass('required btn-danger').show();
                    });
                }
            });
        });
        $(document).on('click', 'button[name="cancel_maintenance"]', function(event){
            event.preventDefault();
            var _this = $(this);
            abcsetup.alerts.confirm('Cancel Maintenance', 'Are you sure you would like to cancel maintenance?', function (resp) {
                if (resp) {
                    abcsetup.form_manager.form.append("<input type='hidden' name='form_action' value='cancel_maintenance'>");
                    abcsetup.form_manager.form.submit();
                }
            });
            // <button type="submit" name="form_action" value="cancel_maintenance" class="btn btn-warning  button cancel_maintenance mr-3" formnovalidate>Cancel Maintenance</button>
        });
    },

    /**
     * _jquery.fieldLib
     *      Fields have been init - this is the callback
     */
    fieldsInit: function() {
        // Note: all front store form related JS is handled in the global /forms/_front_store_item.js form namespace
        abcsetup.front_store.form.init(true);
    },

    /**
     * _jquery.uploader
     *      An upload is complete this is the callback
     */
    uploadDone: function() {
    // attachmentAdded: function() {
        var button = '<a href="/attachments/download/' + abcsetup.uploader.uploadResult.upload_uuid + '" class="col-12 col-md-3 text-center attachment-link-thumb" target="_blank">\
                                                <input type="hidden" name="file_attachments[]" value="' + abcsetup.uploader.uploadResult.id + '">\
                                                <img src="/attachments/thumb/' + abcsetup.uploader.uploadResult.upload_uuid + '">\
                                                <br>';

        if (abcsetup.uploader.uploadResult.type_name) {
            button = button + abcsetup.uploader.uploadResult.type_name + '<br>';
        }

        button = button + '<small>' + abcsetup.uploader.uploadResult.filename + '</small>\
                                                <i class="far fa-trash-alt text-danger delete-attachment" title="Delete Attachment" id="'+abcsetup.uploader.uploadResult.type+'"></i>\
                                            </a>';

        $('#attachments .existing .row').append(button);

        // Auto save the item form
        // $('#uploader-modal').modal('hide');
        $('button#'+abcsetup.uploader.uploadResult.type).removeClass('required btn-danger').hide();
        // abcsetup.front_store.maintenance.edit._autoSave();
    },

    /**
     * set required on the primary glamour shot based on value of has_image
     */
    _hasImageSelectChanged: function() {
        abcsetup.toggleRequired(document.querySelector('input[data-idx=primary_glamour_shot]'), (document.getElementById('has_image').value == 'Y'));
    },

    /**
     * Init any field restrictions/values
     */
    _initFields: function() {
        require('./_common_rules');
    },

    /**
     * Init the attachment buttons
     */
    _initAttachments: function() {
        $(abcsetup.front_store.maintenance.removeButtons).each(function() {
            $('button#' + this).remove();
            $('input[data-idx="' + this + '"]').remove();
        });

        /*
        // Manually apply showIf rules to buttons and their input fields
        $('button#sds_waiver, input[data-idx="sds_waiver"]').attr('showIf', 'sds_waiver=N');
        abcsetup.fieldLib.bindElement($('button#sds_waiver, input[data-idx="sds_waiver"]'), 'showIf');

        $('button#msds_sheet, input[data-idx="msds_sheet"]').attr('showIf', 'sds_waiver=Y');
        abcsetup.fieldLib.bindElement($('button#msds_sheet, input[data-idx="msds_sheet"]'), 'showIf');

        $('button#pr_registration_doc, input[data-idx="pr_registration_doc"]').attr('showIf', 'pr_registration=Y');
        abcsetup.fieldLib.bindElement($('button#pr_registration_doc, input[data-idx="pr_registration_doc"]'), 'showIf');
        */

        $("button#other_upload_button").removeClass("required btn-danger").hide();
        $("button#prescribing_information_attachment").removeClass("required btn-danger").hide();
        $("button#spec_sheet").removeClass("required btn-danger").hide();
        $("button#sds_waiver").addClass("required btn-danger").hide();
        $("button#msds_sheet").removeClass("required btn-danger").hide();
        $("button#case_label").removeClass("required btn-danger").hide();
        $("button#pr_registration_doc").removeClass("required btn-danger").hide();
        $("button#front_panel_product_image").removeClass("required btn-danger").hide();
        $("button#flat_product_bar_code_image").removeClass("required btn-danger").hide();

        // Monitor button class changes from _common_rules
        setInterval(function() {
            $('.item_attachments button').each(function() {
                var id = $(this).attr('id');
                if ($(this).hasClass('required')) {
                    $(this).addClass('btn-danger');
                    var field = $('input.attachment_file[data-idx="' + id + '"]').filter(function() { return $(this).val() == ""; });

                    // Add a new required field for an additional attachment of the current type
                    if (field.length == 0) {
                        field = $('<input type="text" name="file_attachments[]" class="attachment_file" fieldValidate="attachmentFile" data-type="' + $(this).html() + '" data-idx="' + id + '" autocomplete="off">');
                        $(this).after(field);
                    }

                    field.show().attr('required', true);

                } else {
                    var fields = $('input.attachment_file[data-idx="' + id + '"]');
                    fields.hide().attr('required', false);
                }
            });
        }, 500);

    },

    // /**
    //  * Auto save the item form
    //  */
    // _autoSave: function() {
    //     $('form.front-store-item').append('<input type="hidden" class="tmp-action" name="form_action" value="update">');
    //     axios.post('/front_store/' + abcsetup.item.id + '?auto=t', $('form.front-store-item').serialize()).then(response => {
    //         $('form.front-store-item').find('.tmp-action').remove();
    //     });
    // },

    uploadDoneAfterAutoAppend() {
        if (abcsetup.uploader.button.closest('#images_tab').length > 0 && $(abcsetup.uploader.button).data('type') !== 'glamour_shot') {
            $(abcsetup.uploader.button)
                .closest('.attachments')
                .find('.attachment-link-thumb')
                .removeClass(['col-12', 'col-md-3']);
        }

        var mfg_part_num = $('#mfg_part_num').val();
        var case_ean = $('#case_ean').val();
        var inner_ean = $('#inner_ean').val();
        if ($(abcsetup.uploader.button).data('type') == 'flat_product_bar_code_image' &&
            (mfg_part_num != abcsetup.item.mfg_part_num ||
                case_ean != abcsetup.item.case_ean ||
                inner_ean != abcsetup.item.inner_ean
            )
        ) {
            $("button#spec_sheet").removeClass("required btn-danger");
        }

        if ($(abcsetup.uploader.button).data('type') == 'spec_sheet' &&
            (mfg_part_num != abcsetup.item.mfg_part_num ||
                case_ean != abcsetup.item.case_ean ||
                inner_ean != abcsetup.item.inner_ean
            )
        ) {
            $("button#flat_product_bar_code_image").removeClass("required btn-danger");
        }
    },
}
